// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"1aab6a23","710":"a223d416","983":"a7793f57"}[chunkId] + ".chunk.js";
};